<template>

  <div class="content-center tap-highlight" @click="onClickWeight">
    <div class="content-center-first">
      <img class="top-img" src="/static/images/icons.png" alt="">
      <div class="top-first-eidt">
        <span class="we-info">我的测量</span>
        <span class="we-rights">{{weightTime}}</span>
      </div>
    </div>
    <transition name="fade">
      <div class="content-center-second" v-show="shows">
        <div class="contents">
          <div class="content">
            <div>体重</div>
            <span>{{userWeight}}</span>kg
          </div>
          <div class="content">
            <div>分数</div>
            <span>{{score || '--'}}</span>分
          </div>
        </div>
        <div v-if='!score' class='zero-score-tip'>需要结合体脂率等身体成分才能进行身体评分哦</div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'measure',
  props: ['userWeight', 'weightTime', 'until', 'score'],
  data() {
    return {
      shows: true,
    }
  },
  methods: {
    onClickWeight() {
      this.shows = !this.shows
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/assets/css/common.scss';
.user-content .content-center {
  width: 100%;
}
.content-center-first img {
  width: 0.23rem;
  height: 0.22rem;
  display: inline-block;
  position: relative;
  top: 0;
  left: 50%;
  margin-left: -0.125rem;
}
.content-center .top-first-eidt {
  width: 100%;
  padding: 0 0.18rem;
  box-sizing: border-box;
}
.we-info {
  font-size: 16px;
  color: #fee058 !important;
  line-height: 21px;
}
.we-rights {
  font-size: 16px;
  color: #fee058;
  line-height: 21px;
  float: right;
  font-family: 'Arial';
}
/*.content-top{*/
/*width: 100%;*/
/*height: 1.25rem;*/
/*background-color: #1FD2BA;*/
/*padding: 0 0.18rem;*/
/*box-sizing: border-box;*/
/*position: relative;*/
/*overflow: hidden;*/
/*}*/
.content-second .img {
  width: 1.32rem;
  height: 1.1rem;
  display: inline-block;
  position: absolute;
  bottom: 0;
  left: 60%;
}
.content-second .header-img {
  width: 0.6rem;
  height: 100%;
  float: left;
  padding: 0 0.18rem 0 0.08rem;
}
.header-img img {
  width: 100%;
  height: 0.6rem;
  display: inline-block;
  border-radius: 50%;
  margin-top: 0.14rem;
}
.content-second .person-info {
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  z-index: 5;
}
.show-info {
  margin: 0.14rem 0;
  z-index: 5;
}
.show-info span {
  color: #fff;
  font-size: 0.15rem;
  font-family: 'Arial';
}
.content-center {
  background-color: #1fd2ba;
}
.content-center-first {
  width: 100%;
  height: 0.54rem;
  background-color: #fdaa09;
  border-radius: 0.15rem 0.15rem 0 0;
}
.content-center .content-center-second {
  width: 100%;
  height: 1.25rem;
  background-color: #fdaa09;
  padding: 0 0.18rem;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}
.weight .value {
  font-size: 0.48rem;
  color: #fff;
  font-family: 'Arial';
}
.weight .until {
  font-size: 0.18rem;
  color: #fff;
}
.second-back .weights {
  z-index: 5;
  /* margin-top: 0.18rem; */
  color: #fff;
  font-size: 0.18rem;
  text-align: left;
}
@media screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) {
  /* 兼容iphone5 */
  .content-top .content-second {
    padding: 0 0.14rem;
  }
  .content-second .header-img {
    padding-right: 0.1rem;
  }
  .content-second .img {
    left: 57%;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0 !important;
}
.contents {
  padding-top: 0.2rem;
  color: white;
  display: flex;
  justify-content: space-between;
  .content {
    display: inline-block;
    font-size: 18px !important;
    > span {
      font-size: 48px !important;
    }
    > div {
      font-size: 15px !important;
    }
  }
}
.zero-score-tip {
  color: #fff;
  font-size: 12px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/template/measure.vue